const specs = {
  standard: {
    operation: 'create',
    create: {
      type: 'bool',
      product: 'commercialFloorplan_standard',
    },
  },
};


const dependencies = {
  hard: [],
  soft: [],
};


export default { specs, dependencies };
